export enum OnboardingStep {
  RECIPIENT = 'RECIPIENT',
  HEADLINE = 'HEADLINE',
  DESIGN = 'DESIGN',
  SENDER = 'SENDER',
}
